import { useEffect } from 'react'
import ElectronIPC, { IpcWindowChangedEventData } from './ElectronIPC'
import { persistent } from './LocalStorage'
import { logger } from './Logger'
import { getWindowLocationPathname } from '@/utils'

const log = logger.createChildLogger({ name: 'ChooseInitialModePage' })

function usePersistentWindowMetrics({ key, appliedLocations }: { key: string; appliedLocations: string[] }) {
    useEffect(() => {
        const storedWindowMetrics = persistent.getObject(key)
        if (storedWindowMetrics) {
            ElectronIPC.setWindowBounds(storedWindowMetrics)
        }

        const windowChangedHandler = (data: IpcWindowChangedEventData) => {
            if (data.windowName !== 'mainWindow') {
                return
            }

            const location = getWindowLocationPathname()
            if (appliedLocations.includes(location)) {
                log.isVerbose() &&
                    log.verbose(
                        'usePersistentWindowMetrics',
                        `(location=${location}) saving key=${key} ` +
                            `windowMetrics=${JSON.stringify(data.windowMetrics)}.`
                    )
                persistent.set(key, data.windowMetrics)
            } else {
                log.isVerbose() &&
                    log.verbose(
                        'usePersistentWindowMetrics',
                        `(location=${location}) no-op because the ` +
                            `location not in appliedLocations=${JSON.stringify(appliedLocations)}.`
                    )
            }
        }

        ElectronIPC.registerWindowChangedHandler(windowChangedHandler)

        return () => {
            log.verbose('usePersistentWindowMetrics', `(key=${key}) deregistering handler.`)
            ElectronIPC.removeWindowChangedHandler(windowChangedHandler)
        }
    }, [])
}

export default usePersistentWindowMetrics
